interface ChipWithCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ChipWithCheckmarkSVG = ({ color, style }: ChipWithCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_47160)">
      <path
        d="M41.8451 26C41.8451 34.7514 34.7515 41.845 26 41.845C17.2486 41.845 10.155 34.7514 10.155 26C10.155 17.2486 17.2486 10.155 26 10.155C34.7515 10.155 41.8451 17.2486 41.8451 26Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 42L26 51"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6782 48.1842H32.3391V40.7633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3218 48.1842H19.6609V40.7633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 10L26 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6782 3.81592H32.3391V11.2368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3218 3.81592H19.6609V11.2368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.845 26H51.4591"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.1842 13.3218V19.6609H40.7633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.1842 38.6782V32.3391H40.7633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.155 26H0.540894"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="3 3"
      />
      <path
        d="M3.81592 13.3218V19.6609H11.2368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81592 38.6782V32.3391H11.2368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0646 33.3678C33.0108 31.722 34.8848 27.167 33.2502 23.1939C31.6157 19.2207 27.0915 17.334 23.1453 18.9797C19.1991 20.6255 17.3252 25.1805 18.9598 29.1536C20.5943 33.1268 25.1184 35.0135 29.0646 33.3678Z"
        stroke={color}
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.6857 26.15L25.6577 27.9287L28.513 24.4127"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_47160">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ChipWithCheckmarkSVG;
